import React from "react";
import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
/** Can grow to be anything we want this to be. First iteration, is used for button (NOT LINK) with an icon */

var Dropdown = function Dropdown(props) {
  return /*#__PURE__*/React.createElement(StyledDropdown, props);
};

var StyledDropdown = styled(Form.Select).withConfig({
  displayName: "Dropdown__StyledDropdown",
  componentId: "sc-ooq9tq-0"
})(["border:none !important;border-bottom:1px solid #ced4da !important;background-color:transparent;box-shadow:none !important;border-radius:0 !important;&:focus{outline:none;box-shadow:none !important;}"]);
export default Dropdown;